import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ImageMaster_Create, ImageMaster_Update, ImageMaster_Delete, ImageMaster_ReadById, ImageMaster_ReadByMasterId, ImageMaster_ReadAll } from "src/app/GlobalVariables";
import { ImageMasterDTO, ImageMasterList, ImageMasterCreateRequestDTO, ImageMasterDeleteRequestDTO, ImageMasterReadByIdRequestDTO, ImageMasterReadByMasterIdRequestDTO, ImageMasterUpdateRequestDTO } from "./image-master.interface";

@Injectable({
    providedIn: 'root'
})
export class ImageMasterService {
    
    constructor() { }

    http = inject(HttpClient)

    ImageMaster_Create(data: ImageMasterCreateRequestDTO): Observable<ImageMasterDTO> {
        return this.http.post<ImageMasterDTO>(ImageMaster_Create, data)
    }

    ImageMaster_Update(data: ImageMasterUpdateRequestDTO): Observable<ImageMasterDTO> {
        return this.http.post<ImageMasterDTO>(ImageMaster_Update, data)
    }

    ImageMaster_Delete(data: ImageMasterDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(ImageMaster_Delete, data)
    }

    ImageMaster_ReadById(data: ImageMasterReadByIdRequestDTO): Observable<ImageMasterDTO> {
        return this.http.post<ImageMasterDTO>(ImageMaster_ReadById, data)
    }

    ImageMaster_ReadByMasterId(data: ImageMasterReadByMasterIdRequestDTO): Observable<ImageMasterList> {
        return this.http.post<ImageMasterList>(ImageMaster_ReadByMasterId, data)
    }

}